import {Stack, Typography} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {Loading} from 'presentation/components/Loading/Loading';
import {
	StyledCard,
	StyledCardActionArea,
	StyledIconButtonContainer,
	StyledIconIllustration,
	StyledStack,
} from './styles';
import {SupportCardProps} from './types';

export function SupportCard({
	icon,
	title,
	description,
	buttonIcon = 'arrow-right-filled',
	isDisabled = false,
	isLoading = false,
	dataTestId,
	onClick,
	dataTagId,
}: SupportCardProps) {
	return (
		<StyledCardActionArea
			onClick={onClick}
			data-testid={dataTestId}
			data-tag-id={dataTagId}
			disabled={isDisabled}>
			<StyledCard variant="outlined">
				<StyledStack>
					<StyledIconIllustration customIconName={icon} variant="primary" size="medium" />
					<Stack>
						<Typography variant="body1" color="primary">
							{title}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{description}
						</Typography>
					</Stack>
				</StyledStack>
				<StyledIconButtonContainer>
					{isLoading ? <Loading size={20} /> : <Icon name={buttonIcon} size={24} />}
				</StyledIconButtonContainer>
			</StyledCard>
		</StyledCardActionArea>
	);
}
